package com.schoolconnect.app.feature.attendance

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.layout.onGloballyPositioned
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.currentAppDateLabel
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOrangeSoft
import com.schoolconnect.app.designsystem.AppOrangeText
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.PageWindow
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.feature.parentnotes.AddParentNoteDialog
import com.schoolconnect.app.feature.parentnotes.ParentNoteStudentPrefill
import com.schoolconnect.app.feature.parentnotes.ParentNoteStudentOption
import com.schoolconnect.app.feature.parentnotes.ParentNotesUiEvent
import com.schoolconnect.app.feature.parentnotes.ParentNotesViewModel
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.activity_calendar
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.half_day_evening
import ischoolconnect.sharedui.generated.resources.half_day_morning
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.yield

@Composable
fun AttendanceScreen(
    state: AttendanceUiState,
    onEvent: (AttendanceUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    var quickMarkDialogVisible by remember { mutableStateOf(false) }
    var editingRow by remember { mutableStateOf<AttendanceRowUi?>(null) }
    var historyStudent by remember { mutableStateOf<AttendanceInsightRowUi?>(null) }
    var selectedParentNoteStudent by remember { mutableStateOf<ParentNoteStudentPrefill?>(null) }
    // Parent Notes has its own roster/picker APIs. Do not start that work while
    // Attendance is opening; it is only needed after the user chooses Add Note.
    val parentNotesViewModel = remember { ParentNotesViewModel(autoLoad = false) }
    val parentNotesState by parentNotesViewModel.uiState.collectAsState()
    androidx.compose.runtime.DisposableEffect(parentNotesViewModel) {
        onDispose { parentNotesViewModel.clear() }
    }
    LaunchedEffect(state.quickMarkSaveCompleted) {
        if (state.quickMarkSaveCompleted) {
            quickMarkDialogVisible = false
            onEvent(AttendanceUiEvent.QuickMarkSaveAcknowledged)
        }
    }
    LaunchedEffect(state.attendanceEditCompleted) {
        if (state.attendanceEditCompleted) {
            editingRow = null
            onEvent(AttendanceUiEvent.AttendanceEditAcknowledged)
        }
    }
    // API responses are already filtered, sorted, and paged. Keep the screen
    // presentation-only so page ranges always use the server's exact count.
    val pageItems = state.rows
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)
    val insightPageItems = state.insightRows
    val insightWindow = pageWindow(state.pageIndex, state.pageSize, state.insightTotal)

    AdminListPageScaffold(
        title = "Attendance",
        subtitle = "Mark and manage attendance across your assigned classes.",
        backgroundColor = AppBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = {
            ShellTopRightActions(
                roleLabel = shellRoleLabel(shellRoleCode),
                roleSubtitle = shellRoleSubtitle(shellRoleCode),
                initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)),
                expanded = profileExpanded,
                onExpandedChange = { profileExpanded = it },
                onChangeRole = onChangeRole,
                onLogout = onLogout
            )
        },
        secondaryHeader = {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Row(horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                    AttendanceTabItem("Mark Attendance", AttendanceTab.MARK_ATTENDANCE, state.selectedTab, onEvent)
                    AttendanceTabItem("Attendance Insights", AttendanceTab.INSIGHTS, state.selectedTab, onEvent)
                }
            }
        },
        summaryCards = {
            if (state.isLoading) {
                AdminListSummaryCardsShimmer(cardCount = if (state.selectedTab == AttendanceTab.INSIGHTS) 5 else 5)
            } else if (state.selectedTab == AttendanceTab.INSIGHTS) {
                InsightMetricCard("Total Students", state.insightStudentCount.toString(), "Across all classes", Res.drawable.users, AppPrimary, AppPrimarySoft)
                InsightMetricCard("Average Attendance", "${state.insightAverage}%", "Across all students", Res.drawable.users, AppSuccess, AppSuccessSoft)
                InsightMetricCard("Good Performance (>90%)", state.goodPerformanceCount.toString(), "Students", Res.drawable.circle_check, AppSuccess, AppSuccessSoft)
                InsightMetricCard("Average Performance (75–90%)", state.averagePerformanceCount.toString(), "Students", Res.drawable.users, AppOrangeText, AppOrangeSoft)
                InsightMetricCard("Needs Attention (<75%)", state.needsAttentionCount.toString(), "Students", Res.drawable.ban, AppDanger, AppDangerSoft)
            } else {
                AttendanceSummaryCard("Total Students", state.totalStudents.toString(), "Across all classes", Res.drawable.users, AppPrimary, AppPrimarySoft)
                AttendanceSummaryCard("Present (P)", state.presentCount.toString(), "Students", Res.drawable.circle_check, AppSuccess, AppSuccessSoft)
                AttendanceSummaryCard("Absent (A)", state.absentCount.toString(), "Students", Res.drawable.ban, AppDanger, AppDangerSoft)
                AttendanceSummaryCard("Half Day (A-M)", state.halfDayAmCount.toString(), "Students", Res.drawable.half_day_morning, AppOrangeText, AppOrangeSoft)
                AttendanceSummaryCard("Half Day (A-A)", state.halfDayAaCount.toString(), "Students", Res.drawable.half_day_evening, AppOrangeText, AppOrangeSoft)
            }
        },
        toolbar = {
            if (state.selectedTab == AttendanceTab.INSIGHTS) InsightsFilterPanel(state, onEvent) else AttendanceFilterPanel(state, onEvent)
        },
        table = { modifier ->
            if (state.selectedTab == AttendanceTab.INSIGHTS) {
                AttendanceInsightsTable(
                    modifier = modifier,
                    state = state,
                    rows = insightPageItems,
                    window = insightWindow,
                    rowsPerPageExpanded = rowsPerPageExpanded,
                    onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                    onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                    onEvent = onEvent,
                    onViewHistory = { historyStudent = it },
                    onAddParentNote = {
                        it.toParentNoteStudentPrefill().also { student ->
                            parentNotesViewModel.onEvent(ParentNotesUiEvent.StudentPrefilled(student.toParentNoteStudentOption()))
                            selectedParentNoteStudent = student
                        }
                    }
                )
            } else AdminListTableCard(
                modifier = modifier,
                surfaceColor = Color.White,
                borderColor = AppBorder,
                minContentWidth = 920.dp,
                header = { AdminListSortHeaderRow(listOf(
                    AdminListSortColumn("Roll No", .8f, state.sortField == AttendanceSortField.ROLL_NUMBER, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.ROLL_NUMBER)) },
                    AdminListSortColumn("Student Name", 1.45f, state.sortField == AttendanceSortField.STUDENT_NAME, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.STUDENT_NAME)) },
                    AdminListSortColumn("Class", .9f, state.sortField == AttendanceSortField.CLASS, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.CLASS)) },
                    AdminListSortColumn("Status", 1f, state.sortField == AttendanceSortField.STATUS, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.STATUS)) },
                    AdminListSortColumn("Remarks", 1.45f, state.sortField == AttendanceSortField.REMARKS, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.REMARKS)) }
                ), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center) },
                body = {
                    if (state.isLoading) {
                        AdminListTableShimmer(columns = listOf(
                            AdminListHeaderColumn("Roll No", .8f), AdminListHeaderColumn("Student Name", 1.45f), AdminListHeaderColumn("Class", .9f), AdminListHeaderColumn("Status", 1f), AdminListHeaderColumn("Remarks", 1.45f), AdminListHeaderColumn("Actions", .95f)
                        ), rowCount = state.pageSize)
                    } else if (pageItems.isEmpty()) {
                        Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { Text("No attendance records found", color = AppNavy, fontWeight = FontWeight.Bold) }
                    } else {
                        AdminListTableBody(items = pageItems, key = { it.key }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                            AttendanceTableRow(
                                row = row,
                                onStatusChanged = { status -> onEvent(AttendanceUiEvent.StatusChanged(row.key, status)) },
                                onEdit = { editingRow = row },
                                onViewHistory = {
                                    historyStudent = state.insightRows.firstOrNull {
                                        it.rollNumber == row.rollNumber && it.classLabel == row.classLabel
                                    }
                                },
                                onAddParentNote = {
                                    row.toParentNoteStudentPrefill().also { student ->
                                        parentNotesViewModel.onEvent(ParentNotesUiEvent.StudentPrefilled(student.toParentNoteStudentOption()))
                                        selectedParentNoteStudent = student
                                    }
                                }
                            )
                            if (row != pageItems.last()) HorizontalDivider(color = AppBorder)
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageFooterText(window, "students"),
                        pageIndex = window.pageIndex,
                        pageCount = window.pageCount,
                        onPageChanged = { onEvent(AttendanceUiEvent.PageChanged(it)) },
                        pageSize = state.pageSize,
                        rowsPerPageExpanded = rowsPerPageExpanded,
                        onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                        onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                        onPageSizeChanged = { onEvent(AttendanceUiEvent.PageSizeChanged(it)) }
                    )
                }
            )
        },
        bottomAction = {
            if (state.selectedTab == AttendanceTab.MARK_ATTENDANCE) {
                Spacer(Modifier.weight(1f))
                AdminListPrimaryActionButton(
                    label = "Quick Mark",
                    icon = painterResource(Res.drawable.plus),
                    onClick = { quickMarkDialogVisible = true; onEvent(AttendanceUiEvent.QuickMarkClicked) },
                    modifier = Modifier.padding(top = 4.dp)
                )
            }
        }
    )

    QuickMarkAttendanceDialog(
        visible = quickMarkDialogVisible,
        students = state.quickMarkRosterRows,
        classOptions = state.availableClasses,
        initialClassSectionId = state.filters.classSectionId,
        initialDate = state.filters.date,
        isRosterLoading = state.isQuickMarkRosterLoading,
        isAttendanceRecordsLoading = state.isQuickMarkAttendanceLoading,
        rosterErrorMessage = state.quickMarkRosterError,
        isSaving = state.isQuickMarkSaving,
        errorMessage = state.saveErrorMessage,
        onDismiss = { quickMarkDialogVisible = false },
        onContextChanged = { classSectionId, date -> onEvent(AttendanceUiEvent.QuickMarkContextChanged(classSectionId, date)) },
        onSave = { submission ->
            onEvent(AttendanceUiEvent.QuickMarkSaved(submission))
        }
    )

    editingRow?.let { row ->
        EditAttendanceDialog(
            row = row,
            date = state.filters.date.takeUnless { it == "Today" }.orEmpty().ifBlank { currentAppDateLabel() },
            isSaving = state.isAttendanceSaving,
            errorMessage = state.saveErrorMessage,
            onDismiss = { if (!state.isAttendanceSaving) editingRow = null },
            onSave = { date, status, remarks ->
                onEvent(AttendanceUiEvent.AttendanceEdited(row.key, date, status, remarks))
            }
        )
    }

    historyStudent?.let { student ->
        AttendanceHistoryDialog(
            student = student,
            onDismiss = { historyStudent = null }
        )
    }
    selectedParentNoteStudent?.let { student ->
        AddParentNoteDialog(
            visible = true,
            onDismiss = { selectedParentNoteStudent = null },
            initialStudent = student,
            pickerState = parentNotesState,
            onStudentSelected = { parentNotesViewModel.onEvent(ParentNotesUiEvent.StudentSelected(it)) },
            onSave = { parentNotesViewModel.onEvent(ParentNotesUiEvent.CreateRequested(it)) },
            errorMessage = parentNotesState.pickerError
        )
    }
}

@Composable
private fun AttendanceTabItem(label: String, tab: AttendanceTab, selected: AttendanceTab, onEvent: (AttendanceUiEvent) -> Unit) {
    Column(modifier = Modifier.clickable { onEvent(AttendanceUiEvent.TabChanged(tab)) }, horizontalAlignment = Alignment.CenterHorizontally) {
        Text(label, color = if (selected == tab) AppPrimary else AppNavy, fontWeight = FontWeight.Bold, modifier = Modifier.padding(horizontal = 8.dp, vertical = 8.dp))
        Box(Modifier.width(170.dp).height(2.dp).background(if (selected == tab) AppPrimary else Color.Transparent))
    }
}

@Composable
private fun RowScope.AttendanceSummaryCard(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, soft: Color) {
    AdminListSummaryCard(
        title, value, subtitle, painterResource(icon), accent, soft, accent,
        modifier = Modifier.weight(1f), surfaceColor = Color.White, borderColor = AppBorder,
        textColor = AppNavy, cardHeight = 104.dp,
        contentPadding = PaddingValues(horizontal = 10.dp, vertical = 10.dp),
        iconSize = 40.dp, iconGlyphSize = 20.dp, contentSpacing = 6.dp,
        titleFontSize = 12.sp
    )
}

@Composable
private fun RowScope.InsightMetricCard(
    title: String,
    value: String,
    subtitle: String,
    icon: org.jetbrains.compose.resources.DrawableResource,
    accent: Color,
    soft: Color
) {
    AppCard(
        modifier = Modifier.weight(1f).height(104.dp).border(1.dp, accent.copy(alpha = .14f), RoundedCornerShape(8.dp)),
        containerColor = Color.White
    ) {
        Row(Modifier.fillMaxWidth().padding(10.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(40.dp).background(soft, RoundedCornerShape(8.dp)), contentAlignment = Alignment.Center) {
                Icon(painterResource(icon), null, tint = accent, modifier = Modifier.size(20.dp))
            }
            Spacer(Modifier.width(6.dp))
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(3.dp)) {
                Text(
                    title,
                    color = AppNavy,
                    style = androidx.compose.material3.MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.Bold,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
                AppText(value, color = accent, style = androidx.compose.material3.MaterialTheme.typography.headlineMedium, fontWeight = FontWeight.ExtraBold)
                AppText(subtitle, color = AppNavy, style = androidx.compose.material3.MaterialTheme.typography.bodySmall)
            }
        }
    }
}

@Composable
private fun InsightsFilterPanel(state: AttendanceUiState, onEvent: (AttendanceUiEvent) -> Unit) {
    AppCard(
        modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)),
        containerColor = Color.White
    ) {
        Row(
            Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 14.dp),
            verticalAlignment = Alignment.Bottom,
            horizontalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
                Text("Class", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                InsightsDropdown(state.classFilterLabel, state.filters.className.ifBlank { state.classFilterLabel }, state.insightClassOptions, Modifier.fillMaxWidth()) {
                    onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(className = it, classSectionId = state.availableClasses.firstOrNull { option -> option.label == it }?.id.orEmpty())))
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
                Text("Time Period", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                InsightsDropdown("Overall", state.filters.timePeriod.ifBlank { "Overall" }, listOf("Last 7 Days", "Last 30 Days", "This Month"), Modifier.fillMaxWidth()) {
                    onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(timePeriod = it)))
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1.45f)) {
                Text("Search (Student / Roll No.)", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                AdminListSearchField(
                    value = state.searchQuery,
                    onValueChange = { onEvent(AttendanceUiEvent.SearchChanged(it)) },
                    placeholder = "Search by name or roll no.",
                    width = 280.dp,
                    height = 44.dp,
                    surfaceColor = Color.White,
                    borderColor = AppBorder,
                    textColor = AppNavy,
                    cursorColor = AppPrimary,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
                Text("Performance", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                InsightsDropdown("All", state.filters.performance.ifBlank { "All" }, listOf("Good", "Average", "Low"), Modifier.fillMaxWidth()) {
                    onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(performance = it)))
                }
            }
            OutlinedButton(onClick = { onEvent(AttendanceUiEvent.FiltersReset) }, modifier = Modifier.width(116.dp).height(44.dp), shape = RoundedCornerShape(8.dp)) {
                Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(18.dp), tint = AppPrimary)
                Spacer(Modifier.width(8.dp))
                Text("Clear", color = AppPrimary, fontWeight = FontWeight.Bold)
            }
        }
    }
}

@Composable
private fun InsightsDropdown(
    allLabel: String,
    value: String,
    options: List<String>,
    modifier: Modifier,
    onSelected: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val selectionScope = rememberCoroutineScope()
    val density = LocalDensity.current
    fun select(option: String) {
        selectionScope.launch {
            yield()
            delay(500)
            expanded = false
            onSelected(option)
        }
    }
    Box(modifier.onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }) {
        OutlinedButton(onClick = { expanded = true }, modifier = Modifier.fillMaxWidth().height(44.dp), shape = RoundedCornerShape(8.dp)) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Text(value, color = AppNavy, maxLines = 1)
                Icon(painterResource(Res.drawable.chevron_down), null, tint = AppNavy, modifier = Modifier.size(18.dp))
            }
        }
        AppDropdownMenu(expanded, { expanded = false }, width = anchorWidth.takeIf { it > 0.dp }, containerColor = Color.White, shape = RoundedCornerShape(8.dp), border = BorderStroke(1.dp, AppBorder), shadowElevation = 12.dp) {
            DropdownMenuItem(text = { Text(allLabel, color = AppNavy) }, onClick = { select("") })
            options.forEach { option -> DropdownMenuItem(text = { Text(option, color = AppNavy) }, onClick = { select(option) }) }
        }
    }
}

@Composable
private fun AttendanceInsightsTable(
    modifier: Modifier,
    state: AttendanceUiState,
    rows: List<AttendanceInsightRowUi>,
    window: PageWindow,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onEvent: (AttendanceUiEvent) -> Unit,
    onViewHistory: (AttendanceInsightRowUi) -> Unit,
    onAddParentNote: (AttendanceInsightRowUi) -> Unit
) {
    Column(modifier) {
        Row(Modifier.fillMaxWidth().padding(horizontal = 8.dp, vertical = 2.dp), horizontalArrangement = Arrangement.End) {
            LegendDot("Good (>90%)", AppSuccess)
            Spacer(Modifier.width(24.dp)); LegendDot("Average (75–90%)", AppOrangeText)
            Spacer(Modifier.width(24.dp)); LegendDot("Low (<75%)", AppDanger)
        }
        AdminListTableCard(
            modifier = Modifier.fillMaxWidth().weight(1f),
            surfaceColor = Color.White,
            borderColor = AppBorder,
            minContentWidth = 920.dp,
            header = { AdminListSortHeaderRow(listOf(
                AdminListSortColumn("Roll No.", .8f, state.sortField == AttendanceSortField.ROLL_NUMBER, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.ROLL_NUMBER)) },
                AdminListSortColumn("Student Name", 1.45f, state.sortField == AttendanceSortField.STUDENT_NAME, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.STUDENT_NAME)) },
                AdminListSortColumn("Class", .9f, state.sortField == AttendanceSortField.CLASS, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.CLASS)) },
                AdminListSortColumn("Attendance", 1.55f, state.sortField == AttendanceSortField.ATTENDANCE, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.ATTENDANCE)) },
                AdminListSortColumn("Performance", 1f, state.sortField == AttendanceSortField.PERFORMANCE, state.sortAscending) { onEvent(AttendanceUiEvent.SortChanged(AttendanceSortField.PERFORMANCE)) }
            ), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center) },
            body = {
                if (state.isInsightsLoading) AdminListTableShimmer(columns = listOf(
                    AdminListHeaderColumn("Roll No.", .8f), AdminListHeaderColumn("Student Name", 1.45f), AdminListHeaderColumn("Class", .9f), AdminListHeaderColumn("Attendance", 1.55f), AdminListHeaderColumn("Performance", 1f), AdminListHeaderColumn("Actions", .95f)
                ), rowCount = state.pageSize)
                else if (rows.isEmpty()) Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) { Text("No insight records found", color = AppNavy, fontWeight = FontWeight.Bold) }
                else AdminListTableBody(items = rows, key = { it.key }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                    InsightTableRow(row, onViewHistory = onViewHistory, onAddParentNote = onAddParentNote)
                    if (row != rows.last()) HorizontalDivider(color = AppBorder)
                }
            },
            footer = {
                AdminListFooter(
                    pageText = pageFooterText(window, "students"), pageIndex = window.pageIndex, pageCount = window.pageCount,
                    onPageChanged = { onEvent(AttendanceUiEvent.PageChanged(it)) }, pageSize = state.pageSize,
                    rowsPerPageExpanded = rowsPerPageExpanded, onRowsPerPageToggle = onRowsPerPageToggle, onRowsPerPageDismiss = onRowsPerPageDismiss,
                    onPageSizeChanged = { onEvent(AttendanceUiEvent.PageSizeChanged(it)) }
                )
            }
        )
    }
}

@Composable
private fun LegendDot(label: String, color: Color) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(7.dp)) {
        Box(Modifier.size(10.dp).background(color, RoundedCornerShape(50)))
        Text(
            label,
            color = AppNavy,
            fontSize = AdminListTypography.Control,
            fontWeight = AdminListTypography.ControlWeight
        )
    }
}

@Composable
private fun InsightTableRow(
    row: AttendanceInsightRowUi,
    onViewHistory: (AttendanceInsightRowUi) -> Unit,
    onAddParentNote: (AttendanceInsightRowUi) -> Unit
) {
    var actionsExpanded by remember(row.key) { mutableStateOf(false) }
    Row(Modifier.fillMaxWidth().onViewDoubleClick { onViewHistory(row) }.heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        AttendanceCell(row.rollNumber, .8f)
        AppText(
            text = row.studentName,
            color = AppNavy,
            style = androidx.compose.material3.MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Normal,
            modifier = Modifier.weight(1.45f).padding(end = 6.dp)
        )
        AttendanceCell(row.classLabel, .9f)
        Row(Modifier.weight(1.55f).padding(end = 6.dp), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
            Text(
                "${row.attendancePercentage}%",
                color = performanceColor(row.performance),
                fontSize = AdminListTypography.TableBody,
                fontWeight = AdminListTypography.TableBodyWeightStrong
            )
            Text(
                "(P: ${row.presentDays}  |  A: ${row.absentDays}  |  L: ${row.lateDays}  |  E: ${row.excusedDays}  |  T: ${row.totalDays})",
                color = AppNavy,
                fontSize = AdminListTypography.TableBody,
                fontWeight = AdminListTypography.TableBodyWeight
            )
        }
        Box(Modifier.weight(1f).padding(end = 6.dp), contentAlignment = Alignment.CenterStart) {
            Text(
                row.performance,
                color = performanceColor(row.performance),
                fontSize = AdminListTypography.TableBody,
                fontWeight = AdminListTypography.TableBodyWeightStrong
            )
        }
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            AdminListActionIcons(onView = { actionsExpanded = false; onViewHistory(row) }) {
                androidx.compose.material3.IconButton(onClick = { actionsExpanded = true }, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                AdminRowActionMenu(
                    sections = listOf(listOf(AdminRowActionItem("Add Parent Note", { actionsExpanded = false; onAddParentNote(row) }, painterResource(Res.drawable.calendar)))),
                    onDismissRequest = { actionsExpanded = false }, expanded = actionsExpanded, width = 280.dp
                )
            }
        }
    }
}

private fun performanceColor(performance: String): Color = when (performance) {
    "Good" -> AppSuccess
    "Average" -> AppOrangeText
    else -> AppDanger
}

@Composable
private fun AttendanceFilterPanel(state: AttendanceUiState, onEvent: (AttendanceUiEvent) -> Unit) {
    val availableClassOptions = state.availableClasses
    Row(modifier = Modifier.fillMaxWidth().background(Color.White, RoundedCornerShape(10.dp)).border(1.dp, AppBorder, RoundedCornerShape(10.dp)).padding(horizontal = 16.dp, vertical = 14.dp), verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
        Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1.3f)) {
            Text("Search by Name / Roll No.", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
            BoxWithConstraints {
                AdminListSearchField(value = state.searchQuery, onValueChange = { onEvent(AttendanceUiEvent.SearchChanged(it)) }, placeholder = "Search...", width = maxWidth, height = 44.dp, surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy, cursorColor = AppPrimary)
            }
        }
        AttendanceDropdown("Class", state.filters.className.ifBlank { state.classFilterLabel }, availableClassOptions.map { it.label }, Modifier.weight(1f), allOptionLabel = state.classFilterLabel) { value -> onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(className = value, classSectionId = availableClassOptions.firstOrNull { it.label == value }?.id.orEmpty()))) }
        Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
            Text("Date", style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
            AppDialogDateField(value = if (state.filters.date == "Today") currentAppDateLabel() else state.filters.date, onValueChange = { onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(date = it))) }, modifier = Modifier.fillMaxWidth(), colors = AppDialogDefaultColors, fieldHeight = 44.dp, fontSize = androidx.compose.material3.MaterialTheme.typography.bodyMedium.fontSize)
        }
        AttendanceDropdown("Status", state.filters.status.ifBlank { "All" }, com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.codes("ATTENDANCE_STATUS"), Modifier.weight(.9f)) { value -> onEvent(AttendanceUiEvent.FiltersChanged(state.filters.copy(status = value))) }
        OutlinedButton(
            onClick = { onEvent(AttendanceUiEvent.FiltersReset) },
            modifier = Modifier.width(116.dp).height(44.dp),
            shape = RoundedCornerShape(8.dp)
        ) {
            Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(18.dp), tint = AppPrimary)
            Spacer(Modifier.width(8.dp))
            Text("Clear", color = AppPrimary, fontWeight = FontWeight.Bold)
        }
    }
}

@Composable
private fun AttendanceDropdown(label: String, value: String, options: List<String>, modifier: Modifier, allOptionLabel: String = "All", onSelected: (String) -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val selectionScope = rememberCoroutineScope()
    val density = LocalDensity.current
    fun select(option: String) {
        selectionScope.launch {
            yield()
            delay(500)
            expanded = false
            onSelected(option)
        }
    }
    Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = modifier) {
        Text(label, style = androidx.compose.material3.MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
        Box(modifier = Modifier.onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }) {
            OutlinedButton(onClick = { expanded = true }, modifier = Modifier.fillMaxWidth().height(44.dp), shape = RoundedCornerShape(8.dp)) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text(value, color = AppNavy, maxLines = 1)
                    Icon(painterResource(Res.drawable.chevron_down), "Open $label options", tint = AppNavy, modifier = Modifier.size(18.dp))
                }
            }
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                width = anchorWidth.takeIf { it > 0.dp },
                containerColor = Color.White,
                shape = RoundedCornerShape(8.dp),
                border = BorderStroke(1.dp, AppBorder),
                shadowElevation = 12.dp
            ) {
                DropdownMenuItem(text = { Text(allOptionLabel, color = AppNavy) }, onClick = { select("") })
                options.forEach { option -> DropdownMenuItem(text = { Text(option, color = AppNavy) }, onClick = { select(option) }) }
            }
        }
    }
}

@Composable
private fun AttendanceTableRow(
    row: AttendanceRowUi,
    onStatusChanged: (String) -> Unit,
    onEdit: () -> Unit,
    onViewHistory: () -> Unit,
    onAddParentNote: () -> Unit
) {
    var expanded by remember(row.key) { mutableStateOf(false) }
    Row(Modifier.fillMaxWidth().heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        AttendanceCell(row.rollNumber, .8f)
        AttendanceCell(row.studentName, 1.45f, AppNavy, true)
        AttendanceCell(row.classLabel, .9f)
        Box(Modifier.weight(1f).padding(end = 6.dp), contentAlignment = Alignment.CenterStart) { AttendanceStatusChip(row.status) }
        AttendanceCell(row.remarks, 1.45f)
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            AdminListActionIcons(onView = { expanded = false; onViewHistory() }, onEdit = { expanded = false; onEdit() }) {
                androidx.compose.material3.IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                AdminRowActionMenu(
                    sections = listOf(listOf(AdminRowActionItem("Add Parent Note", { expanded = false; onAddParentNote() }, painterResource(Res.drawable.calendar)))),
                    onDismissRequest = { expanded = false }, expanded = expanded, width = 280.dp
                )
            }
        }
    }
}

private fun AttendanceRowUi.toParentNoteStudentPrefill(): ParentNoteStudentPrefill {
    val classParts = classLabel.split('-', limit = 2)
    return ParentNoteStudentPrefill(studentName, classParts.firstOrNull().orEmpty(), classParts.getOrNull(1).orEmpty(), studentId, rollNumber)
}

private fun AttendanceInsightRowUi.toParentNoteStudentPrefill(): ParentNoteStudentPrefill {
    val classParts = classLabel.split('-', limit = 2)
    return ParentNoteStudentPrefill(studentName, classParts.firstOrNull().orEmpty(), classParts.getOrNull(1).orEmpty(), studentId, rollNumber)
}

private fun ParentNoteStudentPrefill.toParentNoteStudentOption() = ParentNoteStudentOption(
    id = studentId,
    name = studentName,
    className = className,
    sectionName = section,
    rollNumber = rollNumber
)

@Composable
private fun RowScope.AttendanceCell(text: String, weight: Float, color: Color = AppNavy, bold: Boolean = false) {
    AdminListTableBodyText(
        text = text,
        color = color,
        fontWeight = if (bold) FontWeight.Bold else FontWeight.SemiBold,
        modifier = Modifier.weight(weight).padding(end = 6.dp)
    )
}

@Composable
private fun AttendanceStatusChip(status: String) {
    AdminListTableBodyText(
        text = status,
        color = attendanceStatusColor(status),
        fontWeight = FontWeight.Bold
    )
}

private fun nextAttendanceStatus(status: String): String = when (status) {
    "P" -> "A"
    "A" -> "A-M"
    "A-M" -> "A-A"
    else -> "P"
}
